import Component from 'core/Component';
import { Event } from 'services/EventEmitter';
import { on, off } from 'toolbox/event';
import { deepMerge } from 'toolbox/deepMerge';

/**
 * This is a description of the Image360Modal constructor function.
 * @class
 * @classdesc This is a description of the Image360Modal class.
 * @extends Component
 */
export default class Image360Modal extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            templateName: 'product/preview360trigger',
            classNames: {},
            contentUrl: '',
            ariaLabel: null, // If defined, this copy will be used as the aria-label of a Modal
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonymous function
     */
    bindEvents() {
        on('click', this.element, this.openModal.bind(this));
        on('product.updated', this.element, this.onProductUpdated.bind(this));
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        if (this.analytics && this.analytics.display) {
            Event.emit('analytics.event', this.analytics.display);
        }
    }

    /**
     * Reload component on product update
     * @param {Object} e event object
     */
    onProductUpdated(e) {
        const model = e.detail.data && e.detail.data.preview360trigger;
        if (model) {
            this.render(model);
        }
    }

    /**
     * Open modal
     *
     * @param {Object} event Event object
     */
    openModal(event) {
        event.preventDefault();

        if (this.options.contentUrl) {
            Event.emit('modal.open', {
                options: {
                    cssPath: 'image360.css',
                    classNames: this.options.classNames || {
                        container: ['m-image360'],
                    },
                    ariaLabel: this.options.ariaLabel,
                    contentUrl: this.options.contentUrl,
                    analytics: {
                        virtualPageURL: '/quick-view{{pathname}}/product-images',
                        virtualPageTitle: 'quick-view/product images',
                    },
                },
            });
        }

        setTimeout(() => {
            if (this.analytics && this.analytics.click) {
                Event.emit('analytics.event', this.analytics.click);
            }
        }, 0);
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off('click', this.element);
        off('product.updated', this.element);
    }
}
